import { useState } from "react";

import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab4 = ({
  IdData,
  AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
  IsFrozen,
  AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
  Disabled,
  BlockSupplier,
  HoldType,
  ReleaseDate
}) => {
  return (
    <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="AllowPurchaseInvoiceCreationWithoutPurchaseOrder"
                    label="Allow Purchase Invoice Creation Without Purchase Order"
                    value={
                      AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.value ||
                      false
                    }
                    onChange={(val) =>
                      AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.setValue?.(
                        val
                      )
                    }
                  />

                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="AllowPurchaseInvoiceCreationWithoutPurchaseReceipt"
                    label="Allow Purchase Invoice Creation Without Purchase Receipt"
                    value={
                      AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.value ||
                      false
                    }
                    onChange={(val) =>
                      AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.setValue?.(
                        val
                      )
                    }
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="IsFrozen"
                    label="Is Frozen"
                    value={IsFrozen?.value || false}
                    onChange={(val) => IsFrozen?.setValue?.(val)}
                  />



                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="Disabled"
                    label="Disabled"
                    value={Disabled?.value || false}
                    onChange={(val) => Disabled?.setValue?.(val)}
                  />
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Block Supplier</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="BlockSupplier"
                    label="Block Supplier"
                    value={BlockSupplier?.value || false}
                    onChange={(val) => BlockSupplier?.setValue?.(val)}
                  />

                </div>
                {BlockSupplier?.value ? (
                  <>
                    <div style={{ flex: 1 }}>
                      <SelectSearch
                        list={[
                          { name: "All" },
                          { name: "Invoices" },
                          { name: "Payments" },
                        ]}
                        style={{
                          height: "30px",
                          border: HoldType?.Error ? "1px solid red" : "",
                        }}
                        label="Hold Type"
                        getOptionLabel={(item) => item.name}
                        getOptionValue={(item) => item.name}
                        value={HoldType?.value || ""}
                        onChange={(value) => HoldType?.setValue?.(value)}
                      />



                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        type="date"
                        id="ReleaseDate"
                        label="Release Date"
                        style={{
                          height: "30px",
                          border: ReleaseDate.Error ? "1px solid red" : "",
                        }}
                        value={ReleaseDate.value}
                        onChange={(e) => ReleaseDate.setValue(e.target.value)}
                      />
                    </div>
                  </>
                ): null}
              </div>




            </div>
          </div>
        </div>
         <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Tab4;
